/**
 * Environment Configuration
 *
 * This file automatically selects the correct environment variables
 * based on the REACT_APP_ENV setting in .env file
 */

const isDevelopment = process.env.REACT_APP_ENV === 'development';

export const env = {
  // Environment mode
  isDevelopment,
  isProduction: !isDevelopment,
  mode: isDevelopment ? 'development' : 'production',

  // Base URLs - automatically selected based on environment
  baseUrl: isDevelopment
    ? process.env.REACT_APP_DEV_BASE_URL
    : process.env.REACT_APP_LIVE_BASE_URL,

  backendUrl: isDevelopment
    ? process.env.REACT_APP_DEV_BACKEND_URL
    : process.env.REACT_APP_LIVE_BACKEND_URL,

  // Stripe - automatically selected based on environment
  stripe: {
    publishableKey: isDevelopment
      ? process.env.REACT_APP_DEV_STRIPE_PUBLISHABLE_KEY
      : process.env.REACT_APP_LIVE_STRIPE_PUBLISHABLE_KEY,
  },

  // Shared variables
  supabase: {
    key: process.env.REACT_APP_SUPABASE_KEY,
  },
};

// Validation: Ensure required environment variables are set
const validateEnv = () => {
  const required = [
    { key: 'baseUrl', value: env.baseUrl },
    { key: 'backendUrl', value: env.backendUrl },
    { key: 'stripe.publishableKey', value: env.stripe.publishableKey },
    { key: 'supabase.key', value: env.supabase.key },
  ];

  const missing = required.filter(({ value }) => !value);

  if (missing.length > 0) {
    console.error('❌ Missing required environment variables:');
    missing.forEach(({ key }) => console.error(`  - ${key}`));
    console.error(`\nCurrent environment: ${env.mode}`);
    console.error('Please check your .env file');
  }
};

// Run validation in development
if (isDevelopment) {
  validateEnv();
}

export default env;
